import React from "react";
import { Alert } from "@material-ui/lab";
import { getLocalizedString } from "@icarius-localization/strings";

const DisabledIndicator = ({ data, isComment }) => {

    if (!data || data?.enabled) return null;

    return (
        <div style={{ marginBottom: 10 }}>
            <Alert variant="filled" severity="error">
                <>
                    {
                        getLocalizedString(isComment ? "commentHasBeenDisabled" : "publicationHasBeenDisabled", { responsibleName: data.responsibleName })
                    }
                    <br />
                    {`${getLocalizedString("reason")}: ${data.reason}`}
                </>
            </Alert>
        </div>
    )
}

export default DisabledIndicator;